import _ from 'lodash';
import { Component, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { ForwarderService, PagerService, CfsModel, CfsModel2, GmapLogService } from '../../../services/index';
import { MapsAPILoader } from '@agm/core';
import { Util } from '../../../utils/util';

declare var $:any;
declare var google:any;

@Component({
  selector: 'cfs-editor',
  templateUrl: 'cfs-editor.html'
})
export class CfsEditorComponent {
  _corpId:number;
  @Input() set corpId(corpId){
    if(!corpId) return;

    this._corpId = corpId;
    this.getFwdrCfsList();
  }
  get corpId(){
    return this._corpId;
  }
  @Output() hideEe: EventEmitter<any> = new EventEmitter();

  cfsList: Array<CfsModel2> = new Array();
  allCfsList: Array<CfsModel2> =  new Array();
  filteredCfsList: Array<CfsModel2> = new Array();
  cfsListForSave: Array<CfsModel> = new Array();

  pager: any = {};
  pagedItems: any[];

  searchText: string = '';

  allCfsChecked:boolean = false;
  
  autocomplete;

  constructor(
    private forwarderService : ForwarderService,
    private pagerService: PagerService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone ,
    private gmapLogService: GmapLogService
  ) {}

  ngOnInit() {
    
  }

  getFwdrCfsList(){
    this.forwarderService.getFwdrCfsList(this.corpId).subscribe(
      resp => {
        if(resp.result) {
          this.cfsList = _.filter(resp.data, {corpId: this.corpId});
          this.allCfsList = _.filter(resp.data, {corpId: null});
          this.filteredCfsList = _.filter(resp.data, {corpId: null});
          this.setPage(1);
        } else {
          $.sweetModal({
            content: resp.errorMsg,
            icon: $.sweetModal.ICON_WARNING,
          });
        }
      }
    );
  }

  setPage(page: number) {
    this.allCfsChecked = false;
    this.pager = this.pagerService.getPager(this.filteredCfsList.length, page, 5);

    // if (page < 1) {
    //   return;
    // } 

    this.pagedItems = this.filteredCfsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  close() {
    this.hideEe.emit();
	}

  clickOutside() {
    this.close();
  } 

  searchCfs(event) {
    var filterValue = event.target.value;
    this.filteredCfsList = [];

    this.filteredCfsList = _.filter(this.allCfsList, item => {
			if (!filterValue) return true;

			let valuesStr = Util.getString(item);
			const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
			return valuesStr.indexOf(filter) >= 0;
    });
    
    this.setPage(1);
  }

  checkAll(isChecked) {
    this.allCfsChecked = true;
    if (_.isEmpty(this.pagedItems)) return;
    for(let k = 0 ; k < this.pagedItems.length; k++) {
      this.pagedItems[k].isChecked = isChecked;
    }
  }

  onChangeInput(index, fieldNm, value) {
    if(this.pagedItems[index]) this.pagedItems[index][fieldNm] = value;
  }

  addToMyCfsList() {
    for(let l = 0; l < this.pagedItems.length; l++) {
      var cfs = this.pagedItems[l];
      if(cfs.isChecked) {
        var code = _.find(this.cfsList, {code : cfs.code});
        if(_.isEmpty(code)) {
          var newCfs = new CfsModel2();
          newCfs = _.clone(cfs);
          newCfs.cfsId = null;
          newCfs.isChecked = false;
          newCfs.corpId = this.corpId;
          
          this.cfsList.push(newCfs);
        } else {
          l++;
        }
      }
    }
  }

  addNewCfs() {
    var cfs = new CfsModel2();
    cfs.corpId = this.corpId;
    this.cfsList.push(cfs); 
  }

  delCfs(idx:number) {

    let that = this;

    $.sweetModal.confirm('삭제하시겠습니까?', function() {
      if (_.isEmpty(that.cfsList)) return;
      
      if(that.cfsList[idx].cfsId != null && that.cfsList[idx].cfsId != undefined){
        that.forwarderService.deleteCfsList(that.corpId, that.cfsList[idx].cfsId).subscribe(
          resp=>{
            if(resp.result) {
              $.sweetModal({
                content: '삭제되었습니다.',
                icon: $.sweetModal.ICON_SUCCESS,
                closeOnClickOutside: false
              });
              that.getFwdrCfsList();
            } else {
              $.sweetModal({
                content: resp.errorMsg,
                icon: $.sweetModal.ICON_WARNING,
                closeOnClickOutside: false
              });
            }
          }
        );
      } 
  
      that.cfsList.splice(idx, 1);
    }, function() {

    });
  }

  
  addNewAutocomplete(index) {
    var input = document.getElementById('cfs-address' + index); 
    this.autocomplete = null;
    this.mapsAPILoader.load().then(() => {

      this.autocomplete = new google.maps.places.Autocomplete(input, {fields: ["name", "address_components", "formatted_address"]});
      this.gmapLogService.log('corp-setting-cfs', 'PLACE');

      let hasDownBeenPressed = false;
      
      input.addEventListener('keydown', (e) => {
        if (e.keyCode === 40) {
          hasDownBeenPressed = true;
        }
      });

      google.maps.event.addDomListener(input, 'keydown', (e) => {
        
        e.cancelBubble = true;
      
        if (e.keyCode === 13 || e.keyCode === 9) {
          if (!hasDownBeenPressed && !e.hasRanOnce) {
            google.maps.event.trigger(e.target, 'keydown', {
                keyCode: 40,
                hasRanOnce: true,
            });
          }
        }
      });

      input.addEventListener('focus', () => {
        hasDownBeenPressed = false;
        $(input).value = '';
      });
      
      this.autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place = this.autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          $(input).value = place.formatted_address;
          this.cfsList[index].address = place.formatted_address;

          for (var i = 0; i < place.address_components.length; i++) {
            for (var j = 0; j < place.address_components[i].types.length; j++) {
              if (place.address_components[i].types[j] == "postal_code") {
                this.cfsList[index].zip = place.address_components[i].long_name;
              }
            }
          }
        });
      });
    });
  }

  saveCfsList() {
    this.cfsListForSave = new Array();
    
    if(this.cfsList) {  
      for(let i = 0; i<this.cfsList.length; i++) {
        var cfs: CfsModel = new CfsModel();
        cfs = _.omit(this.cfsList[i], 'isChecked');
        this.cfsListForSave.push(cfs);
      }
    }

    this.forwarderService.postCfsList(this.cfsListForSave, this.corpId).subscribe(
      resp => {
        if(resp.result) {
          $.sweetModal({
            content: '저장되었습니다.',
            icon: $.sweetModal.ICON_SUCCESS,
            closeOnClickOutside: false
          });
          this.getFwdrCfsList();
        } else {
          $.sweetModal({
            content: resp.errorMsg,
            icon: $.sweetModal.ICON_WARNING,
            closeOnClickOutside: false
          });
        }
      }
    )
  }

}




// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/cfs-editor.ts